function scriptsCard(productCard, color, cod) {
    const colorSelector = productCard.querySelector('.color-selector');
    if (colorSelector?.childElementCount > 0) {
        return
    }
    const sizeSelector = productCard.querySelector('.size-selector');
    const productImage = productCard.querySelector('.product-image');
    const productImageHover = productCard.querySelector('.product-image.hover');
    const productPriceList = productCard.querySelector('.price .list');
    const productPriceBest = productCard.querySelector('.price .best');
    const productInstallments = productCard.querySelector('.installments');
    const variationMessage = productCard.querySelectorAll('.variation-message');
    const addCart = productCard.querySelector('.buy');

    const productLink = productCard.getAttribute('data-product-handle');

    var quickViewSizes = document.querySelector('.selectorMob .sizes');
    const quickView = productCard.querySelector('#buy_mobile');

    let currentId = null;
    let selectedColor = null;
    let selectedSize = null;

    let lowestBest = 0;
    let lowestList = 0;
    let hasDiscount = false;

    const colorInitial = color;

    const codProd = cod;

    // Helper function to build image URLs with width parameter safely
    function buildImageSrcset(baseUrl) {
        const widths = [180, 260, 352, 480, 600];
        return widths.map(width => {
            try {
                // Create absolute URL if baseUrl is relative
                const url = new URL(baseUrl, window.location.href);
                url.searchParams.set('width', width);
                return `${url.toString()} ${width}w`;
            } catch (e) {
                // Fallback for invalid URLs
                const separator = baseUrl.includes('?') ? '&' : '?';
                return `${baseUrl}${separator}width=${width} ${width}w`;
            }
        }).join(', ');
    }

    const query = `
      query ProductsByMetafield {
        collection(handle: "todos-os-produtos") {
          handle
          products(
            first: 100,
            filters: {
              productMetafield: {
                namespace: "custom",
                key: "grupo_de_produto_v2",
                value: "${codProd}"
              }
            }
          ) {
            edges {
              node {
                handle
                title
                images(first: 2) {
                  edges {
                    node {
                      originalSrc
                      altText
                    }
                  }
                }
                metafields(identifiers: [{ namespace: "custom", key: "cor" }]) {
                  value
                }
                variants(first: 20) {
                  edges {
                    node {
                      id
                      availableForSale
                        priceV2 {
                            amount
                            currencyCode
                        }
                        compareAtPriceV2 {
                            amount
                            currencyCode
                        }
                      metafields(identifiers: [{ namespace: "custom", key: "size" }]) {
                        value
                      }
                      image {
                        originalSrc
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }`;

    async function fetchProducts() {
        const response = await fetch('/api/2024-10/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '24b92ef2d877b98ab3edb45d7542f418', // Substitua pelo seu token
            },
            body: JSON.stringify({ query }),
        });

        const result = await response.json();

        const allProducts = result.data.collection.products.edges;
        const availableProducts = allProducts.filter(({ node: product }) => {
            return product.variants.edges.some(({ node: variant }) => variant.availableForSale);
        }).map(({ node: product }) => {
            // Create a new product object with only available variants
            const filteredProduct = { ...product };
            filteredProduct.variants = {
                edges: product.variants.edges.filter(({ node: variant }) => variant.availableForSale)
            };
            return { node: filteredProduct };
        });

        return availableProducts;
    }

    async function updateSelectors() {
        try {
            const products = await fetchProducts();

            if (products.length === 0) {
                console.warn(`Nenhum produto encontrado para o grupo: ${codProd}`);
                selectedColor = color;
                addEventListeners();
                return;
            }

            // Limpar o conteúdo anterior dos seletores
            colorSelector.innerHTML = '';
            sizeSelector.innerHTML = '';

            // Rastrear cores e tamanhos já adicionados para evitar duplicatas
            const addedColors = new Set();
            const addedSizes = new Map(); // Map de color -> Set de tamanhos

            // Find the product with the initial color first
            // Prefere o PRÓPRIO produto do card (handle com código da cor); cai na cor só se não vier na query
            const ownProduct = products.find(({ node: product }) => product.handle === productLink);
            const initialColorProduct = ownProduct || products.find(({ node: product }) =>
                product.metafields?.[0]?.value?.toLowerCase() === colorInitial?.toLowerCase()
            );

            // Se não encontrar o produto com a cor inicial, usar o primeiro produto
            const colorProducts = initialColorProduct ?
                [initialColorProduct, ...products.filter(p => p !== initialColorProduct)] :
                products;

            // Processar todos os produtos, começando pelo de cor inicial se existir
            for (const { node: product } of colorProducts) {                
                const color = product.metafields?.[0]?.value || 'Sem cor';

                // Evitar adicionar cores duplicadas
                if (addedColors.has(color.toLowerCase())) {
                    continue;
                }
                addedColors.add(color.toLowerCase());

                // Inicializar conjunto de tamanhos para esta cor se ainda não existir
                if (!addedSizes.has(color)) {
                    addedSizes.set(color, new Set());
                }

                const hexa = `https://cdn.shopify.com/s/files/1/0939/5339/2919/files/cor-${stringToSlug(color)}.png`;
                const imageUrl = product.images?.edges[0]?.node?.originalSrc || product.featured_image?.src;
                const imageUrlHover = product.images?.edges[1]?.node?.originalSrc || product.featured_image?.src;
                const list_price = product.variants?.edges[0]?.node?.compareAtPriceV2?.amount || 0;
                const best_price = product.variants?.edges[0]?.node?.priceV2?.amount || 0;           

                // Adicionar opção de cor
                colorSelector.innerHTML += `
                    <a href="#" class="color-option" title="${color}" data-bestprice="${best_price}" data-listprice="${list_price}" data-color="${color}" data-image="${imageUrl}" data-imagehover="${imageUrlHover}">
                        <img src="${hexa}" alt="${color}" />
                    </a>`;

                // Se é a primeira cor ou a cor inicial, definir como selecionada
                if (!selectedColor || color.toLowerCase() === colorInitial?.toLowerCase()) {
                    selectedColor = color;
                    // Só sobrescreve a imagem se for o próprio produto do card; senão mantém o SSR do Liquid
                    if (ownProduct && product === ownProduct.node) {
                        productImage.src = imageUrl;
                        productImage.srcset = buildImageSrcset(imageUrl);
                        if (productImageHover) {
                            productImageHover.src = imageUrlHover;
                            productImageHover.srcset = buildImageSrcset(imageUrlHover);
                        }
                    }
                }

                // Adicionar opções de tamanho para esta cor
                if (product.variants && product.variants.edges) {
                    for (const { node: variant } of product.variants.edges) {
                        const size = variant.metafields?.[0]?.value;
                        if (!size) continue;

                        // Evitar adicionar tamanhos duplicados para esta cor
                        if (addedSizes.get(color).has(size)) {
                            continue;
                        }
                        addedSizes.get(color).add(size);

                        const priceList = variant.compareAtPriceV2?.amount || 0;
                        const priceBest = variant.priceV2?.amount || 0;
                        const variantId = variant.id.split('ProductVariant/')[1];

                        const list = parseFloat(priceList);
                        const best = parseFloat(priceBest);                          

                         //menor best price
                        if (best > 0 && best < lowestBest && color == colorInitial ) {
                            lowestBest = best;
                        }

                        //só considera desconto real
                        if (list > best && best > 0 && color == colorInitial) {
                            hasDiscount = true;                           
                            lowestList = list;                          
                        }

                        sizeSelector.innerHTML += `
                            <button class="size-option" data-bestprice="${priceBest}" data-listprice="${priceList}" data-color="${color}" data-size="${size}" data-id="${variantId}" ${!variant.availableForSale ? 'disabled' : ''}>
                                ${size == "." ? "U" : size}
                            </button>`;
                    }
                }

                // Limitar o número de cores mostradas no mobile
                //  && innerWidth < 1024
                if (addedColors.size >= 4) {
                    break;
                }
            }

            // Adicionar link para mais cores no mobile se necessário
            //  && innerWidth < 1024
            if (products.length > 4) {
                colorSelector.innerHTML += '<a style="font-size: 11px;white-space: nowrap;" href="/products/' + productLink + '">+ Cores</a>';
            }
            

            // Selecionar a cor inicial e tamanhos relacionados
            const selectedColorOption = colorSelector.querySelector(`[data-color="${selectedColor}"]`);
            if (selectedColorOption) {
                selectedColorOption.classList.add('selected');

                // Atualizar preços e imagens iniciais
                const priceBest = selectedColorOption.dataset.bestprice;
                const priceList = selectedColorOption.dataset.listprice;
                // Só sobrescreve o preço se o próprio produto veio na query; senão mantém o SSR do Liquid
                if (ownProduct) {
                    updatePriceDisplay(priceBest, lowestList);
                }                
            }

            filterSizeOptionsByColor(selectedColor);
            addEventListeners();
        } catch (error) {
            console.error('Erro ao atualizar seletores:', error);
            // Fallback para garantir que os event listeners sejam adicionados mesmo em caso de erro
            addEventListeners();
        }
    }

    function capitalizeFirstLetter(string) {
        if (typeof string !== 'string' || string.length === 0) {
            return string;
        }
        return string.split(' ').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ');
    }

    function addEventListeners() {
        const colorOptions = productCard.querySelectorAll('.color-option');
        const sizeOptions = productCard.querySelectorAll('.size-option');
        const productTitle = productCard.querySelector('h3 a');

        colorOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                event.preventDefault();

                selectedColor = option.dataset.color;
                const imageUrl = option.dataset.image;
                const imageUrlHover = option.dataset.imagehover;
                const priceBest = option.dataset.bestprice;
                const priceList = option.dataset.listprice;

                // Update the product title with the selected color
                if (productTitle) {
                    const baseTitle = productTitle.textContent.split(' - ')[0]; // Get the base title without color
                    productTitle.textContent = `${baseTitle} - ${capitalizeFirstLetter(selectedColor)}`;
                }

                // Update images
                if (productImage) {
                    productImage.src = imageUrl;
                    productImage.srcset = buildImageSrcset(imageUrl);
                }
                if (productImageHover) {
                    productImageHover.src = imageUrlHover;
                    productImageHover.srcset = buildImageSrcset(imageUrlHover);
                }

                // Update price display
                updatePriceDisplay(priceBest, priceList);

                // Update selected color
                colorOptions.forEach((el) => el.classList.remove('selected'));
                option.classList.add('selected');

                // Reset size selection
                sizeOptions.forEach((el) => el.classList.remove('selected'));
                selectedSize = null;
                currentId = null;

                // Update size options
                filterSizeOptionsByColor(selectedColor);

                // Hide variation message
                if (variationMessage) {
                    variationMessage.forEach((element) => {
                        element.style.display = 'none';
                    });
                }
            });
        });

        sizeOptions.forEach((option) => {
            option.addEventListener('click', () => {
                sizeOptions.forEach((el) => el.classList.remove('selected'));
                option.classList.add('selected');
                selectedSize = option.dataset.size;
                currentId = option.dataset.id;
                const priceBest = option.dataset.bestprice;
                const priceList = option.dataset.listprice;

                // Hide variation message
                if (variationMessage) {
                    variationMessage.forEach((element) => {
                        element.style.display = 'none';
                    });
                }

                // Update price display
                updatePriceDisplay(priceBest, priceList);
                
            });
        });
    }

    function updatePriceDisplay(priceBest, priceList) {
        if (!productPriceBest || !productPriceList || !productInstallments) return;

        let numInstallments = 1;
        let minInstallmentValue = 30.00;

        // O parcelamento máximo é de 6x, o valor mínimo de cada parcela é de R$30,00. Fazemos uma validação reversa.
        for (let i = 6; i >= 1; i--) {
            const installmentValue = priceBest / i;
            if (installmentValue >= minInstallmentValue) {
                numInstallments = i;
                break;
            }
        }

        let installments = numInstallments;
        const installmentValue = Math.trunc((priceBest / installments) * 100) / 100;
        const formattedInstallment = installmentValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });

        // alguns produtos tem o priceList idêntico ao priceBest por questão de cadastro.
        if (+priceList <= +priceBest) {
            productPriceList.style.display = 'none';
        } else {
            productPriceList.style.display = 'block';
            productPriceList.innerHTML = Number(priceList).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            });
        }

        productPriceBest.innerHTML = Number(priceBest).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });

        const pixPrice = ((priceBest - (priceBest * 0.05))).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        let installmentsMessage = `<b>${pixPrice} no PIX</b> ou ${installments}x de ${formattedInstallment} s/ juros`;

        if (installments <= 1) installmentsMessage = `<b>${pixPrice} no PIX</b>`;

        productInstallments.innerHTML = installmentsMessage;
    }

    function filterSizeOptionsByColor(selectedColor) {
        const sizeOptions = productCard.querySelectorAll('.size-option');
        let visibleCount = 0;

        sizeOptions.forEach((size) => {
            const sizeColor = size.dataset.color;
            if (sizeColor && sizeColor.toLowerCase() === selectedColor.toLowerCase()) {
                size.style.display = 'inline-block';
                visibleCount++;
            } else {
                size.style.display = 'none';
            }
        });

    }

    updateSelectors();

    addCart.addEventListener('click', () => {

        if (!currentId) {
            variationMessage.forEach((element) => {
                element.style.display = 'flex';
            });
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                id: currentId,
                quantity: 1,
                properties: {
                    Cor: selectedColor,
                    Tamanho: selectedSize,
                },
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                openMiniCart();
            })
            .catch((error) => {
                console.error('Erro ao adicionar ao carrinho:', error);
            });
    });

    //quickView
    if (quickView) {
        quickView.addEventListener('click', () => {
            if (!quickViewSizes) {
                console.error('quickViewSizes element not found');
                return;
            }

            quickViewSizes.innerHTML = '';
            const listSizes = productCard.querySelectorAll('.size-option');

            if (listSizes && listSizes.length > 0) {
                let hasSizes = false;
                const addedSizes = new Set(); // Para evitar duplicatas

                listSizes.forEach((size) => {
                    let variantId = size.getAttribute('data-id');
                    let color = size.getAttribute('data-color');
                    let sizeValue = size.textContent.trim();
                    let isDisabled = size.hasAttribute('disabled');

                    if (selectedColor.toLowerCase() == color.toLowerCase() && !addedSizes.has(sizeValue)) {
                        addedSizes.add(sizeValue);
                        hasSizes = true;
                        let button = document.createElement('button');
                        button.setAttribute('data-variant-id', variantId);
                        button.setAttribute('data-color', color);
                        button.setAttribute('data-size', sizeValue);
                        button.textContent = sizeValue;

                        if (isDisabled) {
                            button.disabled = true;
                            button.style.opacity = '0.5';
                            button.style.pointerEvents = 'none';
                        }

                        button.addEventListener('click', function () {
                            quickViewSizes.querySelectorAll('button').forEach((btn) => btn.classList.remove('active'));
                            this.classList.add('active');
                        });

                        quickViewSizes.appendChild(button);
                    }
                });

                if (!hasSizes) {
                    quickViewSizes.innerHTML = '<p>Não há tamanhos disponíveis para esta cor</p>';
                }
            } else {
                quickViewSizes.innerHTML = '<p>Não há tamanhos disponíveis</p>';
            }

            document.querySelector('.selectorMob').classList.add('open');
        });
    }
}
